import React, { Component } from 'react';
import json2csv from "json2csv";
import btoa from "btoa";
import '../../styles/css/AdminMain.css'


class ExportCsv extends Component {
  constructor(props) {
      super(props);

      this.state = {

      };
  }
  // or
  // <CSVDownload data={csvData} target="_blank" />

  render() {
    var sessionsResponses = this.props.data;
    var sessions = this.props.sessions;
    var responses = [];
    for(var response in sessionsResponses){
      var sessionKey = sessionsResponses[response].sessionId;
      var session = sessions[sessionKey]
      if(session){
        var sessionName = session.sessionName;
        var sessionId = sessionKey;
        var sessionQuestions = session.questions;
        var answers = sessionsResponses[response].answers;
        for(var answer in answers){
          for(var question in sessionQuestions){
            if(sessionQuestions[question].key === answer){
              responses.push({sessionName: sessionName, sessionId: sessionId, question:sessionQuestions[question].question, answer: sessionQuestions[question].answers[answers[answer]]})
            }
          }
        }
      }
        // sessionsResponses[response].sessionKey)
      // console.log(sessions[sessionsResponses[response].sessionKey])
    }
    var filename = "Session Responses.csv"
    var fields = ['sessionName', 'sessionId', 'question', 'answer'];
    var csv = json2csv({ data: responses, fields: fields});
    const fileContent = "data:text/plain;base64," + btoa(csv);
      return (
        <div className="question-box">
          <a download={filename}
              href={fileContent}
              className="btn btn-default btn-admin btn-create-question">
              Download CSV <i className="fa fa-download"/>
          </a>
        </div>
      )
  }
}

export default ExportCsv;



// WEBPACK FOOTER //
// ./src/components/utils/ExportCsv.js